<template>
  <e-charts
    ref="line"
    autoresize
    :options="option"
    theme="theme-color"
    auto-resize
    class="echart-stacked-area"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markLine'
import 'echarts/lib/chart/line'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    option() {
      const series = this.optionData?.series || []
      const colors = ['#28C76F', '#7367F0', '#FF9F43', '#EA5455', '#00CFE8']

      const getAverage = (values) => {
        if (!Array.isArray(values) || values.length === 0) return null
        const nums = values
          .map((v) => (typeof v === 'number' ? v : Number(v)))
          .filter((v) => Number.isFinite(v))
        if (nums.length === 0) return null
        const sum = nums.reduce((acc, v) => acc + v, 0)
        return sum / nums.length
      }
      
      // Serileri isme göre ayır ve doğru Y eksenine bağla
      const coloredSeries = series.map((s) => {
        const isAdet = s.name === 'Adet'
        const isToplam = s.name === 'Toplam'
        const avg = isAdet || isToplam ? getAverage(s.data) : null
        return {
          ...s,
          stack: undefined, // Stack'i kaldır
          yAxisIndex: isAdet ? 0 : 1,
          itemStyle: { color: isAdet ? colors[0] : colors[1] },
          lineStyle: { width: 3 }, // Çizgi kalınlığı
          smooth: false, // Düz çizgi daha net
          ...(avg != null
            ? {
                markLine: {
                  symbol: 'none',
                  lineStyle: {
                    type: 'dashed',
                    width: 1,
                    color: isAdet ? colors[0] : colors[1],
                  },
                  label: { show: false },
                  data: [{ yAxis: avg }],
                },
              }
            : {}),
        }
      })
      
      return {
        color: colors,
        title: {
          text: 'Son 30 Gün Sipariş İstatistikleri',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            let result = `<b>${params[0].name}</b><br/>`
            params.forEach((item) => {
              const value = item.seriesName === 'Adet' 
                ? `${item.value} adet`
                : `${item.value.toLocaleString('tr-TR')} ₺`
              result += `${item.marker} ${item.seriesName}: <b>${value}</b><br/>`
            })
            return result
          },
        },
        legend: {
          data: ['Adet', 'Toplam'],
          left: 'center',
          top: '35px',
          itemGap: 30,
        },
        grid: {
          left: '70px',
          right: '100px',
          top: '90px',
          bottom: '60px',
          containLabel: false,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.optionData?.xAxisData || [],
            axisLabel: {
              rotate: 0,
              fontSize: 11,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            position: 'left',
            splitLine: { 
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#e0e0e0',
              },
            },
            axisLabel: {
              formatter: '{value}',
              color: colors[0],
              fontSize: 11,
            },
            name: 'Sipariş Adedi',
            nameLocation: 'middle',
            nameGap: 50,
            nameTextStyle: {
              fontSize: 12,
              fontWeight: 'bold',
              color: colors[0],
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0],
                width: 2,
              },
            },
          },
          {
            type: 'value',
            position: 'right',
            splitLine: { show: false },
            axisLabel: {
              formatter: (value) => {
                if (value >= 1000) {
                  return `${(value / 1000).toFixed(0)}k ₺`
                }
                return `${value} ₺`
              },
              color: colors[1],
              fontSize: 11,
            },
            name: 'Toplam Tutar',
            nameLocation: 'middle',
            nameGap: 55,
            nameTextStyle: {
              fontSize: 12,
              fontWeight: 'bold',
              color: colors[1],
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1],
                width: 2,
              },
            },
          },
        ],
        series: coloredSeries,
      }
    },
  },
}
</script>

<style scoped>
.echart-stacked-area {
  width: 100%;
  height: 380px;
}
</style>
